export default {
  bind(el, binding, vnode) {
    const field = binding.value;

    function clickFunc(isMinus) {
      return function (event) {
        document.querySelectorAll('.sort-arrow.fas').forEach((node) => {
          node.classList.remove('fas');
          node.classList.add('far');
        });

        vnode.context.sortBy = (isMinus === true ? '-' : '') + field;
        event.target.classList.remove('far');
        event.target.classList.add('fas');
      };
    }

    const arrowWrap = document.createElement('span');
    arrowWrap.classList.add('arrow-wrap');

    const upArrow = document.createElement('i');
    upArrow.classList.add('far');
    upArrow.classList.add('fa-caret-up');
    upArrow.classList.add('sort-arrow');
    upArrow.addEventListener('click', clickFunc(false));

    const downArrow = document.createElement('i');
    downArrow.classList.add('far');
    downArrow.classList.add('fa-caret-down');
    downArrow.classList.add('sort-arrow');
    downArrow.addEventListener('click', clickFunc(true));

    arrowWrap.appendChild(upArrow);
    arrowWrap.appendChild(downArrow);

    el.appendChild(arrowWrap);
  },
};
